import script from "./SettingsTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsTemplate.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__